import { BASE_URL, POPULAR_JOB_ROLES, PUBLIC } from "../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${POPULAR_JOB_ROLES}?perPageCount=6`; 

export const fetchJobRoles = async () => {
  const url = `${API_BASE_URL}`; 
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};